/*
 * @Author: fuyu
 * @Date: 2025-03-13 16:06:17
 * @LastEditors: fuyu
 * @LastEditTime: 2025-03-13 16:06:17
 */

import Cookies from 'js-cookie' 
function getCookieJSON(name) {
    const jsonString = Cookies.get(name);
    return jsonString ? JSON.parse(jsonString) : null;
}
export function getCookieInfo(field) {
    let info = getCookieJSON('yianInfo');  
    if (info) { 
        if (info[field]) {
            return info[field];
        }
    }
    return ''
} 
export function clearAllCookie() {
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } 
}

